import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import * as ActionTypes from '../../../../constants/ActionTypes';
import GlobalStyles from './Styles';
import LinesStyles from './LinesStyles';
import GeneralBackgroundGlobal from './GeneralBackgroundGlobal';
import { onCssLengthChange, onThemePropChange } from '../../../helpers/ThemeStoreHelpers';
import BodyStyles from './BodyStyles';
import { checkPermissionForLevel, checkPermissions } from '../../../../../lib/utils';
import { ACCESS_POINTS_GROUP, ACCESS_POINT_LEVEL } from '../../../../constants/AccessPoints';

const prefix = 'global';

class ThemeGlobal extends Component {
    render() {
        //FIXME This should probably go into app state in the long run
        const categories = [
            {
                tagNameName: 'Main Heading & Page Title',
                tagName: 'heading',
                props: this.props.data.h1,
                sampleText: 'Select a Hotel',
                id: 'theme-text-heading',
                themePropPath: 'global.h1'
            },
            {
                tagNameName: 'Modal Titles',
                tagName: 'modalheading',
                props: this.props.data.h2,
                sampleText: 'Sample Modal Heading',
                id: 'theme-text-modalheading',
                themePropPath: 'global.h2'
            },
            {
                tagNameName: 'Section Heading',
                tagName: 'subheading',
                props: this.props.data.h3,
                sampleText: 'H3 Subheading',
                id: 'theme-text-subheading',
                themePropPath: 'global.h3'
            },
            {
                tagNameName: 'Main Subtitle',
                tagName: 'subtitle',
                props: this.props.data.h4,
                sampleText: 'Info-style message title',
                id: 'theme-text-subtitle',
                themePropPath: 'global.h4'
            },
            {
                tagNameName: 'Small Subtitle',
                tagName: 'body',
                props: this.props.data.h5,
                sampleText: 'H5 SMALL SUBTITLE (LG-SM)',
                id: 'theme-text-body',
                themePropPath: 'global.h5'
            }
        ];
        const body = [
            {
                tagNameName: 'Body',
                tagName: 'smallBody',
                props: this.props.data.font,
                sampleText:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque id tortor in nulla tristique aliquet. Proin eu ante dolor. Cras sit amet lacus metus. Sed laoreet consectetur molestie. Nullam ac dignissim ligula.',
                id: 'theme-text-smallbody'
            }
        ];
        return (
            <div className="ThemeGlobal Theme-Content">
                <h1>Fonts</h1>
                <p className="normal-text">Select colors, fonts and styles for the headers</p>
                <div className="subglobals-main-content">
                    <div className="col-xs-12">
                        <div className="spark-panel spark-mar-t-1 spark-panel-buttons row">
                            <div className="spark-panel__content col-xs-12">
                                {categories.map(style => {
                                    return (
                                        <GlobalStyles
                                            id={style.id}
                                            tagName={style.tagName}
                                            isDisabled={!this.props.hasAccessThemesEdit}
                                            tagNameName={style.tagNameName}
                                            fontData={style.props}
                                            sampleText={style.sampleText}
                                            key={style.id}
                                            themePropPath={style.themePropPath}
                                        />
                                    );
                                })}
                                <BodyStyles
                                    id={body[0].id}
                                    tagName={body[0].tagName}
                                    isDisabled={!this.props.hasAccessThemesEdit}
                                    tagNameName={body[0].tagNameName}
                                    fontData={body[0].props}
                                    sampleText={body[0].sampleText}
                                    key={body[0].id}
                                />
                                <br />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ThemeGlobal.propTypes = {
    children: PropTypes.element
};

const mapStateToProps = state => {
    return {
        ...state.app.data.theme.global,
        ...state.theme.global,
        data: state.app.data.theme.global,
        hasAccessThemesEdit: checkPermissionForLevel(
            state.oauth.accessLevel,
            ACCESS_POINTS_GROUP.THEMES,
            ACCESS_POINT_LEVEL.EDIT,
            state.oauth.userPermissionLevels,
            state.app.selected.level
        )
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onPrimaryBackgroundColorChange: tagName => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_GLOBAL_SET_THEME_PRIMARY_BACKGROUND_COLOR,
                    layer: tagName,
                    primaryBackgroundColor: event.target.value
                });
        },
        onSecondaryBackgroundColorChange: tagName => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_GLOBAL_SET_THEME_SECONDARY_BACKGROUND_COLOR,
                    layer: tagName,
                    secondaryBackgroundColor: event.target.value
                });
        },
        onThemePropChange: onThemePropChange(dispatch, prefix)
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ThemeGlobal);



// WEBPACK FOOTER //
// ./src/components/pages/theme/global/index.js